module.exports = __webpack_public_path__ + "static/img/UTSC老师_Erick.d3ceacd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_Erick.png
// module id = cmig
// module chunks = 0